const APIS = {
  VEHICLE_MANIFEST: "/vehiclemanifestservice/api/vehicle-manifest/",
  BRANCH: "/logisticservice/api/branch/",
  REMARK: "logisticservice/api/remark/",
  DRIVER: "/fleetservice/api/driver/",
  DRIVER_CREATE: "/fleetservice/api/driver/create-rider/",
  MANIFEST_REPORT: "/manifestservice/api/manifest/manifest-report",
  VEHICLE: "fleetservice/api/vehicle/",
  COMMENT: "/commentservice/api/comment/",
  VEHICLE_MANIFEST_ITEMS: "/vehiclemanifestservice/api/vehicle-manifest-item/",
  STATUS: "/logisticservice/api/status/",
  MANIFEST_STATUS: "/manifestservice/api/manifest-settings/",
  VEHICLE_STATUS: "/vehiclemanifestservice/api/vehicle-manifest-settings/",
  DELIVERY_SETTING: "/logisticservice/api/delivery-settings/",
  USER: "/usermanagementservice/api/user/",
  LOCATION: "/logisticservice/api/location/",
  STATUS_NEXT: "logisticservice/api/status/next-status/",
  DELIVERY: "/manifestservice/api/delivery/",
  DELIVERY_ITEMS: "/manifestservice/api/delivery-item/",
  LOGISTIC_ORDER: "/logisticservice/api/order/",
  DARAZ_ORDER: "vehiclemanifestservice/api/daraz-order/",
  PRODUCT_TYPE: "logisticservice/api/product-type/",
  EXCELDOWNLOAD: "/logisticservice/api/order/email-order-excel/",
  DELIVERY_STATUS: "/logisticservice/api/delivery-settings/",
  ORDER: "/logisticservice/api/order/",
  ORDER_HISTORY: "/historyservice/api/history/",
  RUNSHEET: "/runsheetservice/api/runsheet/order-runsheet/",
  INVOICE: "/invoiceservice/api/merchant-invoice/invoice-id/",
  RECEIVER_DETAIL: "/logisticservice/api/receiver-detail/",
  PICKUPREQUEST: "/pickuprequestservice/api/pickup-request/",
  TAX_INVOICE: "invoiceservice/api/tax-invoice/",
  DELIVERY_PARTNER: "/deliveryservice/api/delivery-partner-configurations/",
  ASSIGN_DELIVERY: "/deliveryservice/api/order/assign-delivery/",
  SUB_ORDER: "/logisticservice/api/sub-order/",
};

export default APIS;
